export default __webpack_public_path__ + "static/media/lock.b7dcdad2.svg";